import { defineMessages } from 'react-intl';

export const messages: {
	insightsBannerTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	insightsBannerAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	insightsBannerTitle: {
		id: 'rovo-growth-pulse.insights-banner.title.V3',
		defaultMessage: 'Your weekly insights',
		description: 'Title text displayed in the Rovo insights banner card',
	},
	insightsBannerAriaLabel: {
		id: 'rovo-growth-pulse.insights-banner.aria-label.V3',
		defaultMessage: 'View your weekly insights',
		description: 'Accessible label for the Rovo insights banner card button',
	},
});
